export default __webpack_public_path__ + "static/media/iPhone.149a3fa6.png";